export enum PaymentMethodEnum {
  CREDIT_CARD = 'credit_card',
  IN_STORE = 'in_store',
  CASH = 'cash',
  CARD = 'card',
}

export enum PaymentMethodValid {
  CASH = 'cash',
  CARD = 'card',
}